import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

export interface IStyledTabProps {
  label: string;
  hash: string;
}

export const NuTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
  },
  indicator: {
    backgroundColor: "#00cfbf",
  },
})(Tabs);

export const NuTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: "none",
      minWidth: 0,
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      "&:hover": {
        color: "#00cfbf",
        opacity: 1,
      },
      "&$selected": {
        color: "#00cfbf",
        fontWeight: theme.typography.fontWeightMedium,
      },
      "&:focus": {
        color: "#00cfbf",
      },
    },
    selected: {},
  })
)((props: IStyledTabProps) => (
  <a href={`#${props.hash}`}>
    <Tab disableRipple {...props} />
  </a>
));

export const ShowMore = ({ className }) => (
  <div className={className}>Show more ↓</div>
);
